// SEO Link Fix - Ensure all links have proper href attributes
(function() {
  'use strict';
  
  function fixMissingHrefAttributes() {
    try {
      // Find all anchor tags without href attributes
      const linksWithoutHref = document.querySelectorAll('a:not([href])');
      
      linksWithoutHref.forEach(function(link) {
        // If the link has target="_self" but no href, add a fallback
        if (link.getAttribute('target') === '_self') {
          link.setAttribute('href', '#');
          // console.log('🔧 SEO Fix: Added href="#" to link with target="_self"');
        }
        
        // If the link has no href at all, add a fallback
        if (!link.hasAttribute('href')) {
          link.setAttribute('href', '#');
          // console.log('🔧 SEO Fix: Added href="#" to link without href attribute');
        }
      });
      
      // Also fix any links with empty href attributes
      // BUT: Check data-pr-href first - if it exists and is valid, use that instead
      const linksWithEmptyHref = document.querySelectorAll('a[href=""], a[href="#"]');
      linksWithEmptyHref.forEach(function(link) {
        // Check if data-pr-href exists and is valid
        const dataHref = link.getAttribute('data-pr-href');
        if (dataHref && dataHref !== '' && dataHref !== '#' && dataHref !== 'undefined') {
          link.setAttribute('href', dataHref);
          // console.log('🔧 SEO Fix: Used data-pr-href value:', dataHref);
        } else if (link.getAttribute('href') === '' || link.getAttribute('href') === '#') {
          // Only set to # if no valid data-pr-href exists
          link.setAttribute('href', '#');
          // console.log('🔧 SEO Fix: Fixed empty href attribute');
        }
      });
      
      // Fix any links with undefined href attributes
      const linksWithUndefinedHref = document.querySelectorAll('a[href="undefined"]');
      linksWithUndefinedHref.forEach(function(link) {
        // Check if data-pr-href exists and is valid
        const dataHref = link.getAttribute('data-pr-href');
        if (dataHref && dataHref !== '' && dataHref !== '#' && dataHref !== 'undefined') {
          link.setAttribute('href', dataHref);
          // console.log('🔧 SEO Fix: Used data-pr-href for undefined href');
        } else {
          link.setAttribute('href', '#');
          if (window.logger) {
            window.logger.log('🔧 SEO Fix: Fixed undefined href attribute');
          }
        }
      });
      
    } catch (error) {
      console.warn('SEO Link Fix: Error occurred:', error);
    }
  }

  function annotateExternalLinks() {
    try {
      var currentHost = location.host.replace(/^www\./, '');
      var anchors = document.querySelectorAll('a[href^="http"], a[href^="//"]');
      anchors.forEach(function(a){
        try {
          var url = new URL(a.href, location.origin);
          var linkHost = url.host.replace(/^www\./, '');
          var isExternal = linkHost && linkHost !== currentHost && !linkHost.endsWith('.' + currentHost);
          if (isExternal) {
            // Preserve existing rel parts but ensure required tokens are present
            var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
            ['nofollow','noopener','noreferrer'].forEach(function(token){ if (!rel.includes(token)) rel.push(token); });
            a.setAttribute('rel', rel.join(' ').trim());
            // Open external links in a new tab unless explicitly opted out
            if (!a.hasAttribute('target')) {
              a.setAttribute('target','_blank');
            }
          }
        } catch(e) { /* ignore malformed URLs */ }
      });
    } catch (error) {
      console.warn('SEO Link Fix (external): Error occurred:', error);
    }
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      fixMissingHrefAttributes();
      annotateExternalLinks();
    });
  } else {
    fixMissingHrefAttributes();
    annotateExternalLinks();
  }
  
  // Also run after any dynamic content changes
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      let shouldFix = false;
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (node.tagName === 'A' || node.querySelector && node.querySelector('a'))) {
              shouldFix = true;
            }
          });
        }
      });
      
      if (shouldFix) {
        setTimeout(function(){
          fixMissingHrefAttributes();
          annotateExternalLinks();
        }, 100);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
